/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A product in a product showcase
 * @export
 * @interface ProductShowcaseProduct
 */
export interface ProductShowcaseProduct {
    /**
     * 
     * @type {string}
     * @memberof ProductShowcaseProduct
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProductShowcaseProduct
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductShowcaseProduct
     */
    imageAssetId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductShowcaseProduct
     */
    price?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductShowcaseProduct
     */
    url?: string;
}

/**
 * Check if a given object implements the ProductShowcaseProduct interface.
 */
export function instanceOfProductShowcaseProduct(value: object): value is ProductShowcaseProduct {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function ProductShowcaseProductFromJSON(json: any): ProductShowcaseProduct {
    return ProductShowcaseProductFromJSONTyped(json, false);
}

export function ProductShowcaseProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductShowcaseProduct {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'imageAssetId': json['imageAssetId'] == null ? undefined : json['imageAssetId'],
        'price': json['price'] == null ? undefined : json['price'],
        'url': json['url'] == null ? undefined : json['url'],
    };
}

export function ProductShowcaseProductToJSON(json: any): ProductShowcaseProduct {
    return ProductShowcaseProductToJSONTyped(json, false);
}

export function ProductShowcaseProductToJSONTyped(value?: ProductShowcaseProduct | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'imageAssetId': value['imageAssetId'],
        'price': value['price'],
        'url': value['url'],
    };
}

